/* ==========================================================================
   LOYAL · T4 · THE PDP
   Pairs with sections/loyal-pdp-main.liquid. Read that file's comment first.

   WHAT THIS FILE DOES, AND EQUALLY WHAT IT REFUSES TO DO.

   It does four things: resolves the selected variant from the size radios,
   syncs the gallery with the thumbnails, opens the zoom dialog, and reveals
   the sticky add to bag once the real button has scrolled away.

   IT DOES NOT ADD TO CART. Dawn's `<product-form>` custom element owns that,
   including the fetch, the error message, the cart drawer render and the cart
   events. A second cart implementation is a second thing to keep in step with
   Shopify, and this build does not need one.

   EVERY BEHAVIOUR HERE IS AN UPGRADE ON SOMETHING THAT ALREADY WORKS WITHOUT
   IT. The thumbnails are anchors before this file touches them. The zoom
   button ships hidden and only this file can reveal it. The form POSTs on its
   own. If this script fails to parse, the page still sells a boxer.
   ========================================================================== */

(function () {
  'use strict';

  var REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    initGallery(root);
    initZoom(root);
    initVariants(root);
    initSticky(root);
  }

  /* ------------------------------------------------------------------------
     THE GALLERY
     Thumbnails are real anchors with real hrefs. This upgrades the jump to a
     scroll inside the track, which stops the whole PAGE jumping on mobile, and
     keeps aria-current honest as the visitor swipes.
     ------------------------------------------------------------------------ */
  function initGallery(root) {
    var track = root.querySelector('[data-loyal-track]');
    var thumbs = root.querySelectorAll('[data-loyal-thumb]');
    if (!track || !thumbs.length) return;

    var frames = track.querySelectorAll('[data-loyal-frame]');

    function setCurrent(index) {
      for (var i = 0; i < thumbs.length; i++) {
        var isCurrent = thumbs[i].getAttribute('data-loyal-thumb') === String(index);
        if (isCurrent) {
          thumbs[i].setAttribute('aria-current', 'true');
        } else {
          thumbs[i].removeAttribute('aria-current');
        }
      }
    }

    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].addEventListener('click', function (event) {
        var index = this.getAttribute('data-loyal-thumb');
        var frame = track.querySelector('[data-loyal-frame="' + index + '"]');
        if (!frame) return;

        // preventDefault only once we know the target exists, so a broken id
        // falls back to the browser's own anchor jump rather than doing
        // nothing at all.
        event.preventDefault();
        frame.scrollIntoView({
          behavior: REDUCE_MOTION.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
        setCurrent(index);
      });
    }

    // Sync on swipe. IntersectionObserver against the track itself, so it
    // reports the frame the visitor is actually looking at rather than the one
    // a click last set.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          for (var j = 0; j < entries.length; j++) {
            if (entries[j].isIntersecting) {
              setCurrent(entries[j].target.getAttribute('data-loyal-frame'));
            }
          }
        },
        { root: track, threshold: 0.6 }
      );
      for (var k = 0; k < frames.length; k++) observer.observe(frames[k]);
    }
  }

  /* ------------------------------------------------------------------------
     THE ZOOM
     The buttons ship hidden and are revealed here, so a browser without
     <dialog> never gets a control that does nothing. Liquid has already
     refused to render a zoom button for a photograph too small to carry one,
     which is the part that matters: this is only the transport.
     ------------------------------------------------------------------------ */
  function initZoom(root) {
    var dialog = root.querySelector('[data-loyal-zoom-dialog]');
    var buttons = root.querySelectorAll('[data-loyal-zoom]');
    if (!dialog || !buttons.length) return;
    if (typeof dialog.showModal !== 'function') return;

    var img = dialog.querySelector('[data-loyal-zoom-img]');

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].removeAttribute('hidden');
      buttons[i].addEventListener('click', function () {
        img.setAttribute('src', this.getAttribute('data-zoom-src'));
        img.setAttribute('alt', this.getAttribute('data-zoom-alt') || '');
        dialog.showModal();
      });
    }

    // Click the backdrop to close. The dialog element itself fills only the
    // image, so a click whose target IS the dialog landed outside the content.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    // Drop the source on close so a 2400px image is not held in memory for the
    // rest of the session on a phone.
    dialog.addEventListener('close', function () {
      img.removeAttribute('src');
    });
  }

  /* ------------------------------------------------------------------------
     THE VARIANT PICKER

     The radios carry option VALUES. The hidden [name=id] input carries the
     variant. This resolves one to the other, and it is the only reason the
     radios need a script at all. The <noscript> select in the section is the
     path for a browser that never runs this.

     A SIZE THAT IS SOLD OUT STAYS ON THE PAGE, struck through and selectable.
     A size that disappears cannot be told apart from a size that was never
     made, and the second one is a message this brand does not want to send at
     five sizes.
     ------------------------------------------------------------------------ */
  function initVariants(root) {
    var data = root.querySelector('[data-loyal-variants]');
    var idInput = root.querySelector('[data-loyal-variant-id]');
    if (!data || !idInput) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (e) {
      // A malformed blob must not take the page down. The form still carries
      // the first available variant in the hidden input, so add to bag keeps
      // working and only the picker stops updating.
      return;
    }
    if (!variants || !variants.length) return;

    var radios = root.querySelectorAll('[data-loyal-value]');
    if (!radios.length) return;

    var priceEl = root.querySelector('[data-loyal-price]');
    var stickyPriceEl = root.querySelector('[data-loyal-sticky-price]');
    var submit = root.querySelector('[data-loyal-submit]');
    var submitText = root.querySelector('[data-loyal-submit-text]');
    var stickySubmit = root.querySelector('[data-loyal-sticky-submit]');
    // Its own span: the main label lives in a different button and one element
    // cannot be in two places. Without this the sticky bar kept saying "Add to
    // bag" while the main button said "Select a size".
    var stickyText = root.querySelector('[data-loyal-sticky-submit-text]');
    var strings = window.loyalPdpStrings || {};

    function selectedValues() {
      var values = [];
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          var position = parseInt(radios[i].getAttribute('data-loyal-value'), 10);
          values[position - 1] = radios[i].value;
        }
      }
      return values;
    }

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var options = variants[i].options;
        var same = options.length === values.length;
        for (var j = 0; same && j < options.length; j++) {
          if (options[j] !== values[j]) same = false;
        }
        if (same) return variants[i];
      }
      return null;
    }

    // Mark every value that has no available variant, given what else is
    // currently chosen. With one option this is simply "this size is gone".
    function markAvailability(values) {
      for (var i = 0; i < radios.length; i++) {
        var radio = radios[i];
        var position = parseInt(radio.getAttribute('data-loyal-value'), 10);
        var probe = values.slice();
        probe[position - 1] = radio.value;

        var found = match(probe);
        var label = root.querySelector('label[for="' + radio.id + '"]');
        if (label) {
          label.setAttribute('data-unavailable', found && found.available ? 'false' : 'true');
        }
      }
    }

    function apply() {
      var values = selectedValues();
      var variant = match(values);

      markAvailability(values);

      if (!variant) {
        /* TWO DIFFERENT SITUATIONS WERE SHARING ONE LABEL, and one of them
           told the shopper the product was sold out when it was not.

           Since sizes stopped being pre-selected, a visitor lands here with
           NOTHING chosen. That produced no variant, so the button went
           disabled and read "Unavailable" on every product page at first
           paint. A disabled Unavailable button does not read as "pick a size";
           it reads as "this is gone", and it is the first thing on the page.

           Nothing chosen is a QUESTION not yet answered. A chosen combination
           that does not exist is genuinely unavailable. Only the second one
           deserves a dead button. */
        var nothingChosen = true;
        for (var vi = 0; vi < values.length; vi++) {
          if (values[vi]) { nothingChosen = false; break; }
        }

        idInput.value = '';
        idInput.disabled = true;

        if (nothingChosen) {
          // enabled on purpose: pressing it is how a visitor asks what to do,
          // and loyal-add.js answers by naming the missing choice and moving
          // focus to the size group.
          if (submit) submit.disabled = false;
          if (stickySubmit) stickySubmit.disabled = false;
          if (submitText && strings.chooseSize) submitText.textContent = strings.chooseSize;
          if (stickyText && strings.chooseSize) stickyText.textContent = strings.chooseSize;
        } else {
          if (submit) submit.disabled = true;
          if (stickySubmit) stickySubmit.disabled = true;
          if (submitText && strings.unavailable) submitText.textContent = strings.unavailable;
          if (stickyText && strings.unavailable) stickyText.textContent = strings.unavailable;
        }
        return;
      }

      idInput.value = variant.id;
      idInput.disabled = !variant.available;

      if (priceEl && variant.price) priceEl.textContent = variant.price;
      if (stickyPriceEl && variant.price) stickyPriceEl.textContent = variant.price;

      if (submit) submit.disabled = !variant.available;
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      var label = variant.available ? strings.add : strings.soldOut;
      if (submitText && label) submitText.textContent = label;
      if (stickyText && label) stickyText.textContent = label;

      // Keep the address bar honest, so a copied link reopens on the size that
      // was on screen. replaceState rather than pushState: choosing a size is
      // not a navigation and it must not fill the back button.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Bring the variant's own photograph into view when it has one. Products
      // in this catalogue are one print per product today, so this is usually
      // a no op, and it is here for the day a colourway shares a product.
      if (variant.mediaId) {
        var frame = root.querySelector('[data-media-id="' + variant.mediaId + '"]');
        if (frame) {
          frame.scrollIntoView({
            behavior: REDUCE_MOTION.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      }
    }

    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', apply);
    }

    /* A SINGLE OPTION VALUE IS NOT A CHOICE, SO DO NOT MAKE THEM TAP IT.
       Added 2026-09-26. Every sock is one variant called "One Size" on an option
       named "Size". Nothing was pre-selected, so the button read SELECT A SIZE
       and pressing it bounced the shopper up the page to tap the only value
       there is. Sizes stopped being pre-selected on purpose for the briefs,
       where S to 2XL is a real decision; it was never meant to apply where there
       is exactly one answer. */
    if (radios.length === 1 && !radios[0].checked && radios[0].disabled !== true) {
      radios[0].checked = true;
    }

    // Run once on load so a sold out first size is struck through before
    // anybody touches it.
    apply();
  }

  /* ------------------------------------------------------------------------
     THE STICKY ADD TO BAG
     Revealed only once the real button has left the viewport. It ships hidden,
     so a browser without IntersectionObserver simply never sees it and keeps
     the button that is already on the page.
     ------------------------------------------------------------------------ */
  function initSticky(root) {
    var bar = root.querySelector('[data-loyal-sticky]');
    var actions = root.querySelector('[data-loyal-actions]');
    if (!bar || !actions) return;
    if (!('IntersectionObserver' in window)) return;

    /* SHOW IT ONLY ONCE THE BUY BUTTON HAS BEEN SCROLLED PAST, never before
       it has been reached. The old condition was simply "the actions are not
       intersecting", which is also true at scroll 0, when the gallery fills
       the viewport and the buy button is still BELOW the fold. So the bar
       appeared on first paint at 390 and landed on the product title,
       covering 54 of its 55 pixels: FUNK BLACK BOXER BRIEF was never painted
       on a phone.

       Reserving space in flow was tried first and does nothing, because the
       title sits at the TOP of the info column and the padding is at the
       bottom. The collision is not a flow problem, it is a timing one.

       boundingClientRect.top tells the two cases apart. Above the viewport
       means scrolled past, so offer the shortcut. Below it means not reached
       yet, so stay out of the way: the real button is where the visitor is
       heading anyway. */
    var observer = new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.hidden = !scrolledPast;
      },
      { threshold: 0 }
    );
    observer.observe(actions);
  }

  /* ------------------------------------------------------------------------
     BOOT
     Also on shopify:section:load, because the theme editor re-renders a
     section into the DOM without a page load and every listener above would
     otherwise be bound to markup that no longer exists.
     ------------------------------------------------------------------------ */
  function boot() {
    var roots = document.querySelectorAll('[data-loyal-pdp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-loyal-pdp]');
    if (root) init(root);
  });
})();
